<pxc-paginated-list>
  <div class="flex flex-col gap-2">
    @for (telemonitoring of collection(); track telemonitoring.telemonitoring.id) {
      <pxc-telemonitoring-preview
        class="animate-in fade-in slide-in-from-top-1"
        [actions]="actions()"
        [attr.data-testid]="telemonitoring.telemonitoring.id"
        [displayPatient]="displayPatient()"
        [telemonitoring]="telemonitoring"
        (clicked)="redirect(telemonitoring.telemonitoring)" />
    } @empty {
      <div *transloco="let t" class="mx-auto my-3 flex flex-col items-center justify-center gap-3">
        <pxc-lottie-label
          animation="sequenceEmpty"
          data-testid="empty-state"
          [message]="t('Il n\'y a aucun télésuivi')" />
        <ng-content />
      </div>
    }
  </div>
</pxc-paginated-list>
